import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useI18n } from "../i18n/I18nContext";

export default function CheckoutCancel() {
  const { t, routes } = useI18n();
  return (
    <div data-testid="checkout-cancel-page">
      <Header />
      <main className="bg-white">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
          <p className="eyebrow text-[#016C36] mb-3">Cancel</p>
          <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.05]">{t.cancel.title}</h1>
          <p className="mt-5 text-slate-600 max-w-xl leading-relaxed">{t.cancel.lead}</p>
          <Link to={routes.quote} className="btn-primary mt-8 inline-flex">{t.cancel.back}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
